import React from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import InputComponent from "../../components/UI/InputComponent/InputComponent";
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";
import Dropdown from "../../components/UI/Dropdown/Dropdown";
import { Fragment } from "react";
import { handleDropdown } from "../../helperFunctions/EntryFormHelperFunctions/handleDropdown";

const SearchSection = ({
  values,
  handleSearchChange,
  handleDropdownChange,
  handleSearchSubmit,
  currentStep,
  selectedAction,
  dropdownOptions}) => {
  return (
    <Fragment>
      {currentStep == 2 && selectedAction == "pregled" && (
        <div className="mb-4">
          <Row className="justify-content-center">
            <Col lg={6} md={12} className="align-self-center">
              <Card>
                <Card.Body>
                  <Card.Title>Pretraga</Card.Title>

                  <Form className="searchform" onSubmit={handleSearchSubmit}>
                    <div>
                      <InputComponent
                        onChange={handleSearchChange}
                        value={values.oib}
                        name="oib"
                        id="oibSearch"
                        placeholder={"OIB "}
                        controlLabel="Unesite OIB"
                      />
                      <InputComponent
                        onChange={handleSearchChange}
                        value={values.registarskiBroj}
                        id="regBrSearch"
                        name="registarskiBroj"
                        placeholder={"Registarski broj "}
                        controlLabel="Unesite registarski broj"
                      />
                        <Dropdown
                          hidden
                          label="Vrsta evidencije"
                          value={values.vrstaEvidencije}
                          onChange={handleDropdownChange}
                          asProperty="select"
                          map={dropdownOptions}
                          text="Filtriraj evidenciju"

                          id="filterEvidencija"
                        />
                    </div>
                    <Row>
                      <Col>
                        <ButtonComponent
                          variant="primary"
                          type="submit"
                          className="search-button"
                          block
                        >
                          Pretraga
                        </ButtonComponent>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </Fragment>
  );
};

export default SearchSection;
